import { SR_API_ACTION_UTILITY_USER_ACTIVATE_PARTNER_USER_ACCOUNT } from 'api/utilityActionTypes';

import { onLogicSuccess as onPartnerLoginSuccess } from 'client/actions/UtilityAuth/partnerSignup';

import analytics from 'client/analytics';
import { ANALYTICS_EVENT_UTILITY_USER_LOGIN } from 'client/analytics/eventList';

export default async function activatePartnerUserAccount(
  { state, utilityApiClient },
  { firstName, lastName, phone, email, password, onSuccess },
) {
  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_USER_ACTIVATE_PARTNER_USER_ACCOUNT,
    state: state,
    payload: {
      firstName,
      lastName,
      phone,
      email,
      password,
    },
    async onSuccess({ user }) {
      await onPartnerLoginSuccess({
        state,
        utilityApiClient,
        user,
      });

      analytics.track(ANALYTICS_EVENT_UTILITY_USER_LOGIN);
      onSuccess(user);

      return user;
    },
  });
}
